import { Crown } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollTo } from "@/lib/lenis";

export default function FinalCTA() {
  return (
    <section id="final-cta" className="relative py-32 lg:py-44 overflow-hidden spotlight-top" data-testid="final-cta-section">
      <div className="absolute inset-0 bg-gradient-to-b from-royal-950 via-royal-900/60 to-royal-950" />
      <div className="relative max-w-5xl mx-auto px-5 text-center">
        <Reveal>
          <Crown className="mx-auto text-gold mb-10 animate-float" size={48} />
        </Reveal>
        <h2 className="font-display font-bold tracking-tight leading-[1.05] text-4xl sm:text-6xl lg:text-7xl" data-testid="final-cta-heading">
          <Reveal delay={0.1}><span className="block">YOUR TALENT DESERVES</span></Reveal>
          <Reveal delay={0.25}><span className="block gold-text-animated">THE SPOTLIGHT</span></Reveal>
        </h2>
        <Reveal delay={0.4}>
          <p className="mt-8 font-display italic text-xl text-gold-light" data-testid="final-cta-subline">
            Your journey begins with HA Treasure House.
          </p>
        </Reveal>
        <Reveal delay={0.55}>
          <button
            onClick={() => scrollTo("#register")}
            className="mt-12 rounded-full bg-gold text-royal-950 px-12 py-5 text-sm font-semibold tracking-widest transition-all duration-300 hover:bg-gold-light hover:shadow-[0_0_45px_rgba(212,175,55,0.6)] hover:-translate-y-0.5"
            data-testid="final-cta-register-btn"
          >
            REGISTER NOW
          </button>
        </Reveal>
      </div>
    </section>
  );
}
